import { colors } from "../../themes/colors"
import styled from "styled-components"

export const CareTeamPageBody = styled.main`
  background: ${colors.c_white[500]};
`
